import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import LatestSection from "./components/LatestSection";
import RankingSection from "./components/RankingSection";
import NewsPreview from "./components/NewsPreview";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  useDocumentMeta({
    title: "夜无疆影视大全 - 最新电影电视剧资讯推荐",
    description:
      "夜无疆提供丰富影视内容，涵盖电影、电视剧全集及资讯，满足您的多样观影需求，体验精品影视世界。",
    keywords: "夜无疆,影视大全,电影,电视剧,影视资讯,高清影视,最新电影",
  });

  return (
    <div className="w-full animate-fadeIn">
      <h1 className="sr-only">夜无疆影视大全 - 最新电影、电视剧与影视资讯推荐平台</h1>
      <HeroCarousel />
      <CategoryEntries />
      <LatestSection />
      <RankingSection />
      <NewsPreview />
      <SiteIntro />
    </div>
  );
}